import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalFooter,
  MDBBtn,
} from "mdb-react-ui-kit";
import translations from "../../data/translations";

const Modal = ({ modalOpen, setModalOpen, modalMessage, language }) => (
  <MDBModal open={modalOpen} tabIndex="-1">
    <MDBModalDialog centered>
      <MDBModalContent>
        <MDBModalHeader>
          <MDBModalTitle>
            {modalMessage === translations[language].sent
              ? translations[language].sent
              : translations[language].failed}
          </MDBModalTitle>
        </MDBModalHeader>
        <MDBModalFooter>
          <MDBBtn color="secondary" onClick={() => setModalOpen(false)}>
            {translations[language].close}
          </MDBBtn>
        </MDBModalFooter>
      </MDBModalContent>
    </MDBModalDialog>
  </MDBModal>
);

export default Modal;
